import React, { useState, useEffect } from 'react';
import CarouselImg from '../../assets/Images/carousel/carousel.png';
// import './carousel.css';
// import "./carousel.css";
const Carousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const images = [
        CarouselImg,
        CarouselImg,
        CarouselImg
    ];
    const texts = [
        'Text 1',
        'Text 2',
        'Text 3'
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="flex flex-col">
            <img src={images[currentIndex]} alt="Carousel Image" className='object-contain' />
            <div className="flex flex-row gap-1 justify-center mt-[10px]">
                {images.map((_, index) => (
                    <div
                        key={index}
                        className={`indicator ${index === currentIndex ? 'bg-[#424952]' : 'bg-[#42495240] bg-opacity-[25%]'} w-[10px] h-[10px] rounded-full cursor-pointer`}
                        onClick={() => setCurrentIndex(index)}
                    />
                ))}
            </div>
        </div>
    );
};

export default Carousel;
